import Styles from "../styles/Styles";

import { CustomText } from "../../../components";
import colors from "../../../config/colors";
import { fonts, pagesConfig, Spacing } from "../../../config";
import { useLocation, useNavigate } from "react-router-dom";
import RoleSelect from "../../../components/others/SelectHeader";
import { SessionStorage } from "../../../utils";

type CustomHeaderProps = {
  openMenu: () => void;
  user: any;
};

function Header({ openMenu, user }: CustomHeaderProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const currentCompany = SessionStorage.getItem("company_type");

  const classes = Styles.useStyles();
  const getCurrentPage = (path) => {
    let currentPage = <></>;

    pagesConfig.logged.map((item) => {
      return item.pages.map((element: any) => {
        if (path === element?.path) {
          currentPage = (
            <div>
              <CustomText
                fontSize={18 / 8}
                fontFamily={fonts.bold}
                textColor="#4D585A"
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  paddingRight: "8px",
                }}
              >
                {element?.icon && (
                  <element.icon alt="" className={classes.icon} />
                )}
                {element?.title}
              </CustomText>
              <Styles.TextDescript>{element?.description}</Styles.TextDescript>
            </div>
          );
        }
        return element;
      });
    });
    return currentPage;
  };

  const roleUser = () => {
    if (user?.ROLES.includes("ROLE_ADMIN_BEWIKI")) {
      return "SuperAdmin";
    } else if (user?.ROLES.includes("ROLE_ADMIN")) {
      return "Proprietário";
    } else if (user?.ROLES.includes("ROLE_MANAGER")) {
      return "Gestor";
    } else {
      return "Inquilino";
    }
    // } else if (user?.ROLES.includes("")) { //Adicionar regra para perfil inquilino (integração)
    //   return "INQUILINO";
    // }
    return "";
  };

  return (
    <Styles.Container id="header-menu">
      <Styles.FirstContentGroup>
        <Styles.Rectangle onClick={openMenu}>
          <Styles.IconMenu />
        </Styles.Rectangle>
        {getCurrentPage(location.pathname)}
      </Styles.FirstContentGroup>

      <Styles.UserContentGroup>
        <CustomText
          textColor={colors.gray}
          fontFamily={fonts.semibold}
          fontSize={2}
        >
          {user?.name}
        </CustomText>
        <div
          style={{
            display: "flex",
            flex: "row",
            gap: Spacing(2),
            alignItems: "center",
            paddingTop: Spacing(0.5),
          }}
        >
          <CustomText
            textColor={colors.black}
            fontFamily={fonts.regular}
            style={{ height: "fit-content" }}
            fontSize={1.75}
          >
            {roleUser()}
          </CustomText>
          <CustomText
            textColor={"#00000054"}
            fontFamily={fonts.regular}
            fontSize={2.5}
            style={{ height: "fit-content", lineHeight: "100%" }}
          >
            •
          </CustomText>
        </div>
      </Styles.UserContentGroup>
    </Styles.Container>
  );
}

export default Header;
